import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import { useEffect, useState } from "react";
import CustomSelectSimple from "../../evidencije/CustomSelectSimple";
import CustomSelectMultiple from "../../globalno-dodavanje/CustomSelectMultiple";
import CustomSelectMultipleTwoColumns from "./CustomSelectMultipleTwoColumns";
import axios from "axios";
import parseBullets from "../../../../utils/parseBullets";

const iskustvoAll = ["0", "0.5-1g", "1-2g", "3-5g", "5-10g", "10+g"];

const emptyData = {
  naziv: "",
  spreme: [],
  opis_poslova: "",
  iskustvo: "",
  posebniUslovi: [],
  straniJezici: [],
  vozackaDozvola: [],
  itVestine: [],
  dodatniUslovi: []
};

const styles = {
  button: { padding: "5px 30px", fontWeight: "bold" },
  select: { width: "25%", maxHeight: "340px" }
};

function DodavanjeRadnoMesto({ cancel, id }) {
  const [data, setData] = useState(emptyData);

  const [spremeAll, setSpremeAll] = useState([]);
  const [posebniUsloviAll, setPosebniUsloviAll] = useState([]);
  const [straniJeziciAll, setStraniJeziciAll] = useState([]);
  const [vozackaDozvolaAll, setVozackaDozvolaAll] = useState([]);
  const [itVestineAll, setItVestineAll] = useState([]);
  const [dodatniUsloviAll, setDodatniUsloviAll] = useState([]);

  const { dictionary, baseUrl, selectedMainEntity } = useGlobalContext();

  useEffect(() => {
    const fetchLookups = async () => {
      try {
        const { data: res } = await axios.post(
          `${baseUrl}/workplaces/get_lookups.php`
        );
        if (res.status === 200) {
          setSpremeAll(res.spreme.map((s) => ({ id: s.id, name: s.naziv })));
          setPosebniUsloviAll(
            res.posebni_uslovi.map((s) => ({ id: s.id, name: s.naziv }))
          );
          setStraniJeziciAll(
            res.strani_jezici.map((s) => ({ id: s.id, name: s.naziv }))
          );
          setVozackaDozvolaAll(
            res.vozacke_dozvole.map((s) => ({ id: s.id, name: s.naziv }))
          );
          setItVestineAll(
            res.it_vestine.map((s) => ({ id: s.id, name: s.naziv }))
          );
          setDodatniUsloviAll(
            res.dodatni_uslovi.map((s) => ({ id: s.id, name: s.naziv }))
          );
        }
      } catch (e) {
        console.error("Greška pri učitavanju lookup vrednosti:", e);
      }
    };
    fetchLookups();
  }, []);

  useEffect(() => {
    if (!id) return;
    const fetchOne = async () => {
      try {
        const { data: res } = await axios.post(
          `${baseUrl}/workplaces/read_one.php`,
          {
            workplace_id: id
          }
        );
        if (res.status === 200 && res.data) {
          const w = res.data;
          setData({
            naziv: w.workplace_name,
            spreme: (w.spreme || []).map((x) => ({
              id: x.spreme_id,
              name: x.naziv
            })),
            opis_poslova: w.opis_poslova || "",
            iskustvo: w.iskustvo || "",
            posebniUslovi: (w.posebni_uslovi || []).map((x) => ({
              id: x.posebni_uslovi_id,
              name: x.naziv
            })),
            straniJezici: (w.strani_jezici || []).map((x) => ({
              id: x.strani_jezici_id,
              name: x.naziv
            })),
            vozackaDozvola: (w.vozacke_dozvole || []).map((x) => ({
              id: x.vozacke_dozvole_id,
              name: x.naziv
            })),
            itVestine: (w.it_vestine || []).map((x) => ({
              id: x.it_vestine_id,
              name: x.naziv
            })),
            dodatniUslovi: (w.dodatni_uslovi || []).map((x) => ({
              id: x.dodatni_uslovi_id,
              name: x.naziv
            }))
          });
        }
      } catch (e) {
        console.error("Greška pri učitavanju radnog mesta:", e);
      }
    };
    fetchOne();
  }, [id]);

  const handleChange = (newValue, field) => {
    if (field === "opis_poslova") {
      setData((prev) => ({
        ...prev,
        [field]: parseBullets(newValue)
      }));
      return;
    }
    setData((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleChangeMultiple = (newValue, field) => {
    const newValues = data[field].find((d) => d.id === newValue.id)
      ? data[field].filter((d) => d.id !== newValue.id)
      : [...data[field], newValue];
    setData((prev) => ({ ...prev, [field]: newValues }));
  };

  const handleSacuvaj = async () => {
    try {
      const payload = {
        workplace_name: data.naziv,
        stepen_rizika: data.rizik || null,
        spreme: data.spreme.map((x) => x.id),
        opis_poslova: data.opis_poslova || null,
        iskustvo: data.iskustvo || null,
        company_id: selectedMainEntity.company_id,
        posebni_uslovi: data.posebniUslovi.map((x) => x.id),
        strani_jezici: data.straniJezici.map((x) => x.id),
        vozacke_dozvole: data.vozackaDozvola.map((x) => x.id),
        it_vestine: data.itVestine.map((x) => x.id),
        dodatni_uslovi: data.dodatniUslovi.map((x) => x.id)
      };

      const endpoint = id
        ? `${baseUrl}/workplaces/update_workplace.php`
        : `${baseUrl}/workplaces/create_workplace.php`;

      if (id) payload.workplace_id = id;

      const { data: res } = await axios.post(endpoint, payload);
      if (res.status === 200) {
        window.dispatchEvent(new Event("machineAdded"));
        cancel();
      } else {
        alert("Greška pri čuvanju.");
      }
    } catch (e) {
      console.error("Greška:", e);
      alert("Greška pri čuvanju.");
    }
  };

  const handleOdustani = () => cancel();

  const isDisabledSacuvaj =
    !data.naziv || !data.iskustvo || data.spreme.length === 0;

  return (
    <div
      style={{
        padding: "5px",
        backgroundColor: "#f9f9f9",
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div style={{ overflowY: "auto", flex: 1 }}>
        <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
          <div style={{ width: "25%" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "5px"
              }}
            >
              {dictionary["radnoMesto"]}
            </div>
            <input
              value={data.naziv}
              onChange={(e) => handleChange(e.target.value, "naziv")}
              style={{
                height: "40px",
                padding: "10px",
                fontSize: "16px",
                width: "100%"
              }}
            />
          </div>
          <CustomSelectMultiple
            label={dictionary["strucnaSprema"]}
            allValues={spremeAll}
            selectedValues={data.spreme}
            onSelectChange={(newValue) =>
              handleChangeMultiple(newValue, "spreme")
            }
            displayNumber
            style={{ ...styles.select }}
          />
          <CustomSelectSimple
            label={dictionary["radnoIskustvo"]}
            allValues={iskustvoAll}
            selectedValue={data.iskustvo}
            onSelectChange={(newValue) => handleChange(newValue, "iskustvo")}
            style={{ width: "25%" }}
          />
          <CustomSelectMultiple
            label={dictionary["posebniUslovi"]}
            allValues={posebniUsloviAll}
            selectedValues={data.posebniUslovi}
            onSelectChange={(newValue) =>
              handleChangeMultiple(newValue, "posebniUslovi")
            }
            displayNumber
            style={{ ...styles.select }}
          />
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "flex-end",
            marginTop: "15px"
          }}
        >
          <CustomSelectMultipleTwoColumns
            allValues={straniJeziciAll}
            selectedValues={data.straniJezici}
            onSelectChange={(newValue) =>
              handleChangeMultiple(newValue, "straniJezici")
            }
            label={dictionary["straniJezici"]}
            displayNumber
            style={{ ...styles.select }}
          />
          <CustomSelectMultipleTwoColumns
            allValues={vozackaDozvolaAll}
            selectedValues={data.vozackaDozvola}
            onSelectChange={(newValue) =>
              handleChangeMultiple(newValue, "vozackaDozvola")
            }
            label={dictionary["vozackaDozvola"]}
            displayNumber
            style={{ ...styles.select }}
          />
          <CustomSelectMultipleTwoColumns
            allValues={itVestineAll}
            selectedValues={data.itVestine}
            onSelectChange={(newValue) =>
              handleChangeMultiple(newValue, "itVestine")
            }
            label={dictionary["itVestine"]}
            displayNumber
            style={{ ...styles.select }}
          />
          <CustomSelectMultiple
            allValues={dodatniUsloviAll}
            selectedValues={data.dodatniUslovi}
            onSelectChange={(newValue) =>
              handleChangeMultiple(newValue, "dodatniUslovi")
            }
            label={dictionary["dodatniUslovi"]}
            displayNumber
            style={{ ...styles.select }}
          />
        </div>
        {/* DODAJ OVO */}
        <div style={{ marginTop: "15px" }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px"
            }}
          >
            OPIS POSLOVA
          </div>
          <textarea
            rows={10}
            className="dos-input"
            value={data.opis_poslova}
            onChange={(e) => handleChange(e.target.value, "opis_poslova")}
            style={{
              width: "100%",
              height: "100%",
              padding: "10px",
              fontSize: "16px",
              resize: "none",
              borderBottom: "3px solid #f2f2f2ff",
              borderTop: "3px solid #999999ff",
              borderLeft: "3px solid #f2f2f2ff",
              borderRight: "3px solid #999999ff"
            }}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "15px",
          padding: "0 15px"
        }}
      >
        <div style={{ fontWeight: "bold", fontSize: "30px", width: "25%" }}>
          {data.workplace_id}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "15px",
            width: "75%"
          }}
        >
          <div onClick={handleOdustani} style={{ width: "25%" }}>
            <Button activation={true} style={styles.button}>
              {dictionary["odustani"]}
            </Button>
          </div>
          <div
            onClick={isDisabledSacuvaj ? undefined : handleSacuvaj}
            style={{ width: "25%", opacity: isDisabledSacuvaj ? 0.5 : 1 }}
          >
            <Button activation={true} style={styles.button}>
              {dictionary["sacuvaj"]}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DodavanjeRadnoMesto;
